export const BANK_ACCOUNT_PROVIDERS = {
  PLAID: 'plaid',
  MX: 'mx'
}
